__turbopack_context__.v({
  "body": "ai-disclosure-wording-overrides-module__j2tn2q__body",
  "cell": "ai-disclosure-wording-overrides-module__j2tn2q__cell",
  "editor": "ai-disclosure-wording-overrides-module__j2tn2q__editor",
  "field": "ai-disclosure-wording-overrides-module__j2tn2q__field",
  "headers": "ai-disclosure-wording-overrides-module__j2tn2q__headers",
  "language": "ai-disclosure-wording-overrides-module__j2tn2q__language",
  "row": "ai-disclosure-wording-overrides-module__j2tn2q__row",
  "table": "ai-disclosure-wording-overrides-module__j2tn2q__table",
});
